import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Breadcrump from "../../components/Breadcrump";
import SEO from "../../components/SEO";
import ProductCard from "../products/Card";
import brandAPI from "../../api/brandApi";

function DetailPage() {
  
  const { slug } = useParams();

  const [item, setItem] = useState({});
  const [products, setProducts] = useState([]);
  const [metaData, setMetaData] = useState({});

  const fetchBrandDetails = async () => {
    try {
      const res = await brandAPI.details(slug);

      if (res.code === 200) {
        const result = res.data;

        setItem(result?.brand);
        setProducts(result?.products);
        setMetaData(result?.brand?.meta);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
    }
  };

  useEffect(() => {
    fetchBrandDetails();
  }, [slug]);

  return (
    <>
      <Breadcrump title={item?.name} />

      <SEO meta={metaData} />

      {products && products.length > 0 && (
        <div className="flat-spacing-2" style={{ backgroundColor: "beige" }}>
          <div className="container">
            <div className="flat-animate-tab flat-controltab-nav">
              <div className="flat-title text-start">
                <h4>Our Products</h4>
              </div>
              <div className="row">
                {products.map((product, index) => (
                  <div
                    className="col-lg-3 col-sm-6 col-xs-6 mb-2"
                    key={[product._id || index]}
                  >
                    <ProductCard item={product} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DetailPage;
